import PropTypes from 'prop-types';

export const USER__CREATE = 'USER__CREATE';
export const USER__GET = 'USER__GET';
export const USER__DELETE = 'USER__DELETE';
export const USER__DOWNGRADE = 'USER__DOWNGRADE';
export const USER__LOG_IN = 'USER__LOG_IN';
export const USER__LOG_OFF = 'USER__LOG_OFF';
export const USER__REACTIVATE = 'USER__REACTIVATE';
export const USER__RESET_PASSWORD = 'USER__RESET_PASSWORD';
export const USER__SET_PASSWORD = 'USER__SET_PASSWORD';
export const USER__UPDATE = 'USER_UPDATE';

export const USER__SHAPE_ITEM = PropTypes.shape({
  createdAt: PropTypes.string,
  email: PropTypes.string,
  firstName: PropTypes.string,
  fullName: PropTypes.string,
  id: PropTypes.string,
  lastName: PropTypes.string,
  loggedOn: PropTypes.number,
  role: PropTypes.string,
  timeZone: PropTypes.string,
  token: PropTypes.string,
});
